module.exports = __webpack_public_path__ + "img/empreendimento-logo-33.434c8a5c.png";